import { IBinancePosition } from "../../interfaces/binance";
import { IAggregatedPosition } from "../../interfaces/positions";
import { convertToAevoAssetName } from "../assetNameMappings";

export const retrieveBinanceAssetBySymbol = (symbol: string) => symbol.split("USDT")[0];

export const standardizeBinancePositions = (
  positions: Partial<IBinancePosition>[]
): IAggregatedPosition[] => {
  const standardizedPositions: Record<string, IAggregatedPosition> = {};

  positions.forEach((pos) => {
    if (pos.symbol) {
      const binanceAsset = retrieveBinanceAssetBySymbol(pos.symbol);
      // Convert to Aevo asset name for proper aggregation
      const aevoAsset = convertToAevoAssetName(binanceAsset, "binance");
      const binanceInstrumentName = `${aevoAsset}-PERPETUAL`;

      standardizedPositions[binanceInstrumentName] = {
        instrument_name: binanceInstrumentName,
        asset: aevoAsset,
        side: Number(pos.positionAmt) > 0 ? "buy" : "sell",
        delta: Number(pos.positionAmt),
        contracts: Number(pos.positionAmt),
        gamma: 0,
        vega: 0,
        theta: 0,
        pnl: Number(pos.unRealizedProfit),
        isPerpetual: true,
        source: "Binance",
        binanceDelta: Number(pos.positionAmt),
        binanceMarkPrice: Number(pos.markPrice || 0),
      };
    }
  });

  return Object.values(standardizedPositions);
};
